export default __webpack_public_path__ + "static/media/3id-logo.595b50e5.png";